'use strict';

(function () {

  $(".js-dropdown a").click(function () {
    setTimeout(function () {
      var table = $('#myTabContent .active .js-data-table-rows').DataTable();
      let date = $('.input-datepicker').attr('data-fucking-date');

      table.columns(1).search(date).draw();

      table.columns.adjust().draw();
    }, 200);

    $("#dropdownMenuButton").text($(this).text());
    $("#dropdownMenuButton").val($(this).text());

  });

})();
